module.exports = __webpack_public_path__ + "assets/icon-robot-component.e0595925.svg";